var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfileIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1921_2133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6275 18.6275 24 12 24C5.3725 24 0 18.6275 0 12C0 5.3725 5.3725 0 12 0C18.6275 0 24 5.3725 24 12Z",
    fill: "url(#paint0_linear_1921_2133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.728 11.6221C15.8303 10.7919 16.5444 9.47278 16.5444 7.98981C16.5444 5.48401 14.5057 3.44531 11.9997 3.44531C9.4939 3.44531 7.4552 5.48401 7.4552 7.98981C7.4552 9.47278 8.16913 10.7919 9.27142 11.6221C6.32013 12.7299 4.21387 15.5804 4.21387 18.9141H5.62012C5.62012 15.3962 8.48206 12.5345 11.9999 12.5345C15.5175 12.5345 18.3795 15.3962 18.3795 18.9141H19.7857C19.7855 15.5804 17.6794 12.7299 14.728 11.6221ZM8.86145 7.98981C8.86145 6.25928 10.2692 4.85156 11.9997 4.85156C13.7302 4.85156 15.1379 6.25928 15.1379 7.98981C15.1379 9.72034 13.7302 11.1282 11.9997 11.1282C10.2692 11.1282 8.86145 9.72034 8.86145 7.98981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1921_2133",
    x1: 0,
    y1: 12,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F38D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1921_2133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileIcon);
export default __webpack_public_path__ + "static/media/UserProfileIcon.a7358bbed1b58723c6834b4458b4881a.svg";
export { ForwardRef as ReactComponent };